import { Game } from "../interfaces/game.interface";
import { GameHistoryWithGame } from "../interfaces/gameHistory.interface";
import { User, UserStore } from "../interfaces/user.interface";

class GUserStore {
  data: UserStore = {
    user: {
      id: "",
      first_name: "",
      last_name: "",
      email: "",
      avatar: "",
      summary: "",
      points: 0,
      level: 0,
      created_at: "",
      updated_at: "",
    },
    gameHistory: [],
    achievedStatus: [],
    highscoreGames: [],
    favoriteGames: [],
  };

  setUserData = (action: {
    payload: User;
  }) => {
    this.data.user = action.payload;
  };
  updateUserAvatar = (action: { payload: { avatar: string } }) => {
    if(!this.data.user) return;
    this.data.user.avatar = action.payload.avatar;
  };
  setGameHistory = (action: { payload: { gameHistory: GameHistoryWithGame[] } }) => {
    this.data = {
      ...this.data,
      gameHistory: action.payload.gameHistory,
    };
  };
  setHighscoreGames = (action: {
    payload: { highscoreGames: Array<{ game: Game; score: number }> };
  }) => {
    this.data.highscoreGames = action.payload.highscoreGames;
  };
  setFavoriteGames = (action: { payload: { games: Game[] } }) => {
    this.data.favoriteGames = action.payload.games;
  };
}

export const userStore = new GUserStore();
